/**
 * 广告位跳转公共方法
 *
 * 主要逻辑说明：
 * 1. AppFinanceMemberH5 链接 → RightHelper 处理后使用 openThirdPage 打开（会员H5项目）
 * 2. 非 http(s) 链接：
 *    - hellobike:// scheme → openThirdPage 打开新 WebView
 *    - 其他相对路径 → router.push 当前项目内跳转
 * 3. AppFinanceH5Web 链接 → 截取路由后 router.push（当前项目内跳转）
 * 4. AppFinanceCreditH5 链接 → window.location.href 直接跳转
 * 5. AppFinanceLoanH5 链接 → jumpToNewVersion 跳转（自动添加 fromAppFinanceH5Web 参数）
 * 6. 其他 http(s) 链接 → openThirdPage 兜底处理
 */
import { openThirdPage } from '@/api/native/utils';
import { RightHelper } from '@/shared/right-router-helper';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import router from '@/router';

/**
 * 广告位链接跳转处理
 * @param link 跳转链接
 */
export const advLinkJump = (link: string): void => {
  if (!link) {
    return;
  }

  // 会员H5项目跳转处理
  if (link.includes('AppFinanceMemberH5')) {
    const url = RightHelper.dispatcher(link);
    openThirdPage(url);
    return;
  }

  // 非http(s)链接处理
  if (!/^http(s?):\/\//.test(link)) {
    // 哈啰app内部页面 scheme，打开新的WebView跳转
    if (link.startsWith('hellobike://hellobike.com')) {
      openThirdPage(link);
    } else {
      router.push({
        path: link,
      });
    }
    return;
  }

  // 当前项目链接处理：若"/AppFinanceH5Web/"则认为是当前项目，则直接截取route进行跳转
  if (/\/AppFinanceH5Web\//.test(link)) {
    const [path, hash] = link.split('#');
    const newLink = hash || path.split('/').pop() || '';
    router.push({
      path: newLink,
    });
    return;
  }

  // AppFinanceCreditH5 项目跳转
  if (link.includes('AppFinanceCreditH5')) {
    window.location.href = link;
    return;
  }

  // AppFinanceLoanH5 项目跳转：若是老项目跳到新项目，则统一兜底添加"fromAppFinanceH5Web=true"，让其返回时特殊处理:closeWebview
  if (/\/AppFinanceLoanH5\//.test(link)) {
    let url = link;

    if (!link.includes('fromAppFinanceH5Web=true')) {
      url = `${link}${link.includes('?') ? '&fromAppFinanceH5Web=true' : '?fromAppFinanceH5Web=true'}`;
    }

    jumpToNewVersion(url, false);
    return;
  }

  // 其他链接使用 openThirdPage 跳转
  openThirdPage(link);
};
